
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"15","viewBox":"0 0 15 15","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.619 13.95H4.422a.615.615 0 01-.613-.575l-.532-7.904a.615.615 0 01.614-.657h7.26c.355 0 .637.302.613.657l-.532 7.904a.615.615 0 01-.613.574zM12.37 3.661H2.747c-.01 0-.015-.006-.015-.015V1.964c0-.009.006-.015.015-.015h9.624c.008 0 .014.006.014.015v1.682c0 .008-.006.016-.014.016z"}}),_c('path',{attrs:{"d":"M10.12 2.776H4.979c-.01 0-.015-.005-.015-.014V.849c0-.01.006-.015.015-.015h5.143c.008 0 .014.006.014.015v1.913a.015.015 0 01-.014.014z"}})])
          )
        }
      }
    